// Checkout (Phase 5; woocommerce/checkout/form-checkout.php, inc/checkout.php). WooCommerce's own checkout script
// does the work; this adds the phone summary toggle (with the total kept in step after each refresh), the discount
// code box, which uses WooCommerce's apply_coupon endpoint as its own coupon form does, and (Phase 5b) the same-address
// choice and the delivery terms' visibility.

export function initCheckout() {
    var summary = document.querySelector('[data-co-summary]');
    if (!summary || !window.jQuery) {
        return;
    }
    var $ = window.jQuery, toggle = summary.querySelector('[data-co-toggle]');
    toggle.addEventListener('click', function () {
        var open = summary.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', String(open));
        toggle.querySelector('span').textContent = open ? 'Hide your order' : 'Show your order';
    });
    // "Same as billing address" drives WooCommerce's own "different address" checkbox (hidden), which opens the
    // delivery address fields and makes its script price delivery from that postcode. Collection: a note in its place
    // (CodeRockz removes the delivery address form; 5d); the delivery terms show for delivery only.
    var same = document.querySelector('[data-co-same]'), sameBox = same && same.querySelector('[data-co-same-box]'),
        collect = document.querySelector('[data-co-collect]'), terms = document.querySelector('[data-co-terms]');
    var syncAddress = function () {
        var wcBox = document.querySelector('#ship-to-different-address input');
        if (!sameBox || !wcBox) {
            return;
        }
        var different = !same.hidden && !sameBox.checked;
        if (wcBox.checked !== different) {
            wcBox.checked = different;
            $(wcBox).trigger('change');
        }
    };
    if (sameBox) {
        sameBox.addEventListener('change', syncAddress);
        syncAddress();
    }
    var showFor = function (type) {
        if (same) {
            same.hidden = type === 'pickup';
            syncAddress();
        }
        if (collect) {
            collect.hidden = type !== 'pickup';
        }
        if (terms) {
            terms.hidden = type !== 'delivery';
        }
    };
    $(document.body).on('change', '#coderockz_woo_delivery_delivery_selection_box', function () {
        showFor(this.value);
    });
    var type = document.querySelector('#coderockz_woo_delivery_delivery_selection_box');
    if (type) {
        showFor(type.value); // not a change event: CodeRockz acts on those
    }
    var delivery = document.querySelector('.co-card--delivery');
    $(document.body).on('updated_checkout', function () {
        // A call-for-quote postcode: jfj-commerce marks the payment block and CodeRockz's box is hidden.
        if (delivery) {
            delivery.classList.toggle('is-quote', !!document.querySelector('.jfj-call-for-quote'));
        }
        var amounts = summary.querySelectorAll('.order-total .woocommerce-Price-amount');
        if (amounts.length) {
            summary.querySelector('[data-co-total]').innerHTML = amounts[amounts.length - 1].outerHTML;
        }
    });
    var apply = summary.querySelector('[data-co-apply]'), code = summary.querySelector('[data-co-coupon]');
    if (apply && window.wc_checkout_params) {
        var send = function () {
            if (!code.value.trim()) {
                return;
            }
            apply.disabled = true;
            $.post(wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'apply_coupon'),
                {security: wc_checkout_params.apply_coupon_nonce, coupon_code: code.value.trim()})
                .done(function (html) {
                    $('.woocommerce-notices-wrapper').first().html(html);
                    $(document.body).trigger('update_checkout', {update_shipping_method: false});
                })
                .always(function () {
                    apply.disabled = false;
                });
        };
        apply.addEventListener('click', send);
        code.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault(); // inside the checkout form: Enter would place the order
                send();
            }
        });
    }
}
